import axios from 'axios';
import { getToken } from '@/libs/util';
import { Message } from 'view-design';
import router from '@/router';
import { POBrowser } from 'js-pageoffice';
class HttpRequest {
  constructor(baseUrl) {
    this.baseUrl = baseUrl;
  }

  getInsideConfig() {
    const config = {
      baseURL: this.baseUrl,
    };
    return config;
  }

  interceptors(instance) {
    // 请求拦截
    instance.interceptors.request.use(
      (config) => {
        const token = getToken();
        if (token) {
          POBrowser.setProxyBaseAPI('/');
          // POBrowser.setProxyBaseAPI('/api');
          //必须。向PageOffice后端请求设置header，支持多次调用setHeader()设置更多的值，具体属性名称和属性值以您实际开发为准。
          POBrowser.setHeader('Authorization', token); // 向 PageOffice 后端请求设置 header
        }

        return config;
      },
      (error) => {
        return Promise.reject(error);
      },
    );
    // 响应拦截
    instance.interceptors.response.use(
      (res) => {
        const { data, status } = res;
        if (data.msg === '系统升级完毕,请重新登录') {
          Message.error(data.msg);
          localStorage.removeItem('user');
          router.push({ path: '/login' });
        } else {
          return { data, status };
        }
      },
      (error) => {
        let errorInfo = error.response;
        if (!errorInfo) {
          const {
            request: { statusText, status },
            config,
          } = JSON.parse(JSON.stringify(error));
          errorInfo = {
            statusText,
            status,
            request: { responseURL: config.url },
          };
        }
        const matched = router.app._route.matched;
        const routerView = matched[matched.length - 1].instances.default;
        if (routerView.tableLoading) {
          routerView.tableLoading = false;
        }
        if (routerView.loading) {
          routerView.loading = false;
        }
        Message.error('网络异常，请重新再试！');
        return Promise.reject(error);
      },
    );
  }

  request(options) {
    const token = getToken();
    const instance = axios.create({
      headers: {
        Authorization: `${token}`,
      },
    });
    options = Object.assign(this.getInsideConfig(), options);
    this.interceptors(instance);
    return instance(options);
  }

  aliyunRequest(options) {
    const instance = axios.create({
      headers: {
        Authorization: `${options.AppCode}`,
        CobntentType: 'application/x-www-form-urlencoded; charset=utf-8',
      },
    });
    options = Object.assign(this.getInsideConfig(), options);
    this.interceptors(instance);
    return instance(options);
  }
}
export default HttpRequest;
